import { render, staticRenderFns } from "./BajasComercialesBase.vue?vue&type=template&id=448478dc&"
import script from "./BajasComercialesBase.vue?vue&type=script&lang=ts&"
export * from "./BajasComercialesBase.vue?vue&type=script&lang=ts&"
import style0 from "./BajasComercialesBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports